// Minimal email-client frame around the signature HTML.
export function SignaturePreview({ html, testId = "signature-preview", from = "you@company.com" }) {
  return (
    <div className="overflow-hidden rounded-lg border border-border bg-white text-[#15161A] shadow-sm">
      <div className="flex items-center gap-1.5 border-b border-border bg-[#F6F5F2] px-4 py-2.5">
        <span className="h-2.5 w-2.5 rounded-full bg-[#DAD8D2]" /><span className="h-2.5 w-2.5 rounded-full bg-[#DAD8D2]" /><span className="h-2.5 w-2.5 rounded-full bg-[#DAD8D2]" />
        <span className="ml-3 truncate font-mono text-[11px] text-[#8A8C92]">New message · from {from}</span>
      </div>
      <div className="space-y-4 p-5 sm:p-6">
        <div className="space-y-2" aria-hidden="true">
          <div className="h-2 w-2/3 rounded bg-[#EEECE7]" /><div className="h-2 w-1/2 rounded bg-[#EEECE7]" />
        </div>
        <div className="overflow-x-auto"><div data-testid={testId} dangerouslySetInnerHTML={{ __html: html }} /></div>
      </div>
    </div>
  );
}
